<div class="shop-headline row" *ngIf="step === 'list' || step === 'detail' || step === 'cart' || step === 'download' || (step === 'thankyou' && isDigitalDownloadProcess)" >
	<div class="column small-12 medium-6">
		<h1 [innerHTML]="'shop.headline' | translate"></h1>
	</div>
	<div class="column small-12 medium-6 text-center medium-text-right">
		<shop-cart-icon [currency]="donation.currencySymbol" *ngIf="step === 'list' || step ==='detail'" (click)="setStep('cart')"></shop-cart-icon>
	</div>
</div>

<step-navigation [(step)]="step" [isDigitalDownloadProcess]="isDigitalDownloadProcess" (stepChange)="stepChange($event)" [donation]="donation" [(donationStatus)]="donationStatus" [size]="size" [projectType]="projectType"></step-navigation>

<shop-list *ngIf="step == 'list'" [size]="size" [donation]="donation" (stepChange)="stepChange($event, true)" (onShowItem)="showItem($event)" (onShowDownloadForProduct)="showDownloadForProduct($event)"></shop-list>

<shop-detail *ngIf="step == 'detail'" [item]="currentItem" [currency]="donation.currencySymbol" (onShowDownloadForProduct)="showDownloadForProduct($event)"></shop-detail>

<shop-cart *ngIf="step == 'cart'" [size]="size" [donation]="donation" (stepChange)="stepChange($event, true)"></shop-cart>

<!-- digital download -->
<div class="row" *ngIf="isDigitalDownloadProcess">
	<div class="shop-download">
		<div class="button-wrapper">
			<h2>{{ 'shop.download.ready' | translate }}</h2>
			<a class="button download" target="_blank" [href]="currentItem.file" ><i class="twingle-download"></i>{{ 'shop.download.start.button' | translate }}</a>
		</div>
	</div>
</div>
<shop-download *ngIf="step === 'download'" [product]="currentItem" [digitalDownloadDonation]="digitalDownloadDonation" [form]="widgetPaymentForm" [size]="size" (stepChange)="stepChange($event, true)"></shop-download>

<!-- form for payment, thankyou and end -->
<div class="widget {{ step }}" *ngIf="['list', 'detail', 'cart'].indexOf(step) === -1">

	<!-- payment (small and widget only) -->
	<form onsubmit="document.getElementById('value2').value.length > 0? this.submit() : false" [action]="getFormAction()" [class.event]="projectType == 'event'" [target]="paymentFormTarget" method="POST" (ngSubmit)="submitForm()" [formGroup]="widgetPaymentForm" *ngIf="(step == 'payment' || step == 'payment-select')" novalidate>
		<!-- Status -->
		<donation-status [status]="donationStatus" [message]="donationStatusMessage" [donation]="donation" (statusChange)="onStatusChange($event)"></donation-status>

		<!-- extra field -->
		<extrafield [contact]="contact" [form]="widgetPaymentForm" *ngIf="step == 'payment' && contactMandatory == false"></extrafield>

		<!-- shop summary -->
		<shop-cart-summary [donation]="donation" [form]="widgetPaymentForm" [step]="step" *ngIf="!isDigitalDownloadProcess"></shop-cart-summary>

		<!-- payment -->
		<payment [donation]="donation"  [amount]="donation.amount" [rythm]="donation.rythm" [contact]="contact" [form]="widgetPaymentForm" [(donationStatus)]="donationStatus" [size]=size [(step)]="step" [version]="version" (stepChange)="stepChange($event)"></payment>

		<!-- event Donator -->
		<donator [donation]="donation" [form]="widgetPaymentForm" *ngIf="projectType === 'event' || showDonatorData"></donator>

		<!-- donation data for sending the data to an external form -->
		<hidden-formsubmit [id]="'value2'" [donation]="donation" [contact]="contact" [type]="version" [step]="step" [size]="size" [form]="widgetPaymentForm"></hidden-formsubmit>

		<!-- remarks on this donation -->
		<input-remarks [form]="widgetPaymentForm" [donation]="donation" [wrapperClass]="'remarks-wrapper row column'"></input-remarks>

		<!-- Button -->
		<div class="row columns" *ngIf="step == 'payment'">
			<div id="expresscheckout"></div>
			<submit [text]="paymentSubmitTextkey | translate: getSubmitButtonPlaceholders()" [arrow]="false" [additionalClasses]="widgetPaymentForm.valid? '' : 'grey'" [secureText]="'payment.submit.hint' | translate"></submit>
		</div>
	</form>

	<!-- contact (if contact is mandatory) -->
	<form onsubmit="document.getElementById('value3').value.length > 0? this.submit() : false" [class.event]="projectType == 'event'" [action]="getFormAction()" [target]="paymentFormTarget" method="POST" (ngSubmit)="submitForm()" [formGroup]="contactForm" *ngIf="step == 'contact-mandatory' && contactMandatory == true" novalidate>
		<!-- Status -->
		<donation-status [status]="donationStatus" [message]="donationStatusMessage" [donation]="donation"></donation-status>

		<!-- extra field -->
		<extrafield [contact]="contact" [form]="contactForm"></extrafield>

		<!-- contact data -->
		<contact [donation]="donation" [contact]="contact" [form]="contactForm" [size]="size" [version]="version" [(step)]="step" (stepChange)="stepChange($event, true)"  [country]="donation.userCountry"></contact>

		<!-- donation data for sending the data to an external form -->
		<hidden-formsubmit [id]="'value3'" [donation]="donation" [contact]="contact" [type]="version" [step]="step" [size]="size" [form]="contactForm"></hidden-formsubmit>

		<!-- Button -->
		<div class="row columns">
			<submit [text]="'shop.cart.button' | translate: getSubmitButtonPlaceholders()" [additionalClasses]="contactForm.valid? '' : 'grey'"  [secureText]="step != 'contact' && version == 'page' && size != 'small'? ('payment.submit.hint' | translate) : ''" [arrow]="step != 'contact' && (version == 'widget' || size == 'small')"></submit>
		</div>
	</form>

	<!-- iframe, status -->
	<donation-status [status]="donationStatus" [donation]="donation" [message]="donationStatusMessage" (statusChange)="onStatusChange($event)" *ngIf="step == 'iframe' || step == 'contact-mandatory-finished'"></donation-status>
	<payment-iframe [donation]="donation" [buttonPlaceholders]="getSubmitButtonPlaceholders()" [projectType]="projectType" *ngIf="step == 'iframe'"></payment-iframe>

	<!-- step: thank you -->
	<thankyou-order [step]="step" [projectType]="projectType" [donation]="donation" [contact]="contact" [form]="contactForm" [size]="size" [version]="version" (stepChange)="stepChange($event, true)"></thankyou-order>

	<!-- share -->
	<share *ngIf="projectType == 'event'" [projectType]="projectType" [step]="step"></share>
</div>

<footerdata [(step)]="step" [version]="version" (stepChange)="stepChange($event)" [projectType]="projectType" [size]="size"></footerdata>

<!-- donators -->
<project-donators [projectType]="projectType" [step]="step" [donation]="donation" *ngIf="(projectType == 'event' || showDonatorData) && step != 'banktransfer' && step != 'contact'"></project-donators>

<tracking></tracking>
